import { useUserProfileImageStore } from '@stores/userProfileImageStore';
import type { AvatarSource } from '@therame/ui';
import { computed } from 'vue';

/**
 * The app's side of `AvatarSourceKey` (ADR-0048): a person's picture from the profile
 * image store, asked for once while the store holds none. Every load hands out a fresh
 * object URL, so a picture already held is never loaded again.
 */
export const useAvatarSource = (): AvatarSource => {
  const store = useUserProfileImageStore();
  return (userId) => {
    if (!store.profileImageUrls.has(userId)) void store.loadProfileImageByUserId(userId);
    return computed(() => store.profileImageUrls.get(userId));
  };
};
